import React from 'react';
import { LocalImageThumb } from '../../../../components/local-image-thumb/local-image-thumb';
import { MimeTypeBase } from '../../../../types/entities';
import { toMimeType } from '../../../../utils/mime-type/mime-type';
import { ThumbByFileIdContainer } from '../../operations-table/thumb-by-file-id/thumb-by-file-id.container';
import {
  FileUploadStatus,
  FileUploadStatusType,
} from '../operation-groups.types';

interface Props {
  uploadStatus: FileUploadStatus;
}

export const UploadOperationThumb: React.FunctionComponent<Props> = ({
  uploadStatus,
}: Props) => {
  switch (uploadStatus.type) {
    case FileUploadStatusType.Uploading:
    case FileUploadStatusType.Canceled:
    case FileUploadStatusType.Failed: {
      if (!uploadStatus.file) {
        return null;
      }

      const mimeType = toMimeType(uploadStatus.file.type);

      if (mimeType.type === MimeTypeBase.Image) {
        return (
          <LocalImageThumb file={uploadStatus.file} width={24} height={24} />
        );
      }

      return null;
    }

    case FileUploadStatusType.Uploaded:
      return <ThumbByFileIdContainer fileId={uploadStatus.fileId} />;

    default:
      return null;
  }
};
